import React from 'react';
import ImageUploader from "../ImageUpload/ImageUploader";
import CircularProgress from 'material-ui/CircularProgress';
import RaisedButton from 'material-ui/RaisedButton';
import Solution from './Solution';
import Solution4LongQ from './Solution4LongQ';
import TeXEditor from '../TeXEditor/TeXEditor';
import createConfirm from '../Modal/createConfirm';
import ReactTooltip from 'react-tooltip';
import CustomEditor from "../CustomEditor/CustomEditor";
import ReactDOM from 'react-dom';

var LongQuestionEditor = React.createClass({
  newStructuredQuestion: function () {
    return {
      preText: "",
      postText: "",
      text: "",
      description: "",
      answerValue: 0,
      editorType: this.state.kquestion.subtype && this.state.kquestion.subtype.editor === 'old' ? "NORMAL" : "WIRIS",
      type: "MANUAL_MARKING"
    }
  },
  handleDescriptionChange: function (e) {
    var kquestion = this.state.kquestion;
    kquestion.description = e.target.value;
  },
  handlePreTextChange: function (textInput, e) {
    textInput.preText = e.target.value;
  },
  handlePostTextChange: function (textInput, e) {
    textInput.postText = e.target.value;
  },
  handleAnswerChange: function (textInput, e) {
    textInput.text = e.target.value;
  },
  addPart: function () {
    var kquestion = this.state.kquestion;
    kquestion.textInputAnswers.push(this.newStructuredQuestion());
    if (!kquestion.metadata.textInputAnswers) kquestion.metadata.textInputAnswers = [];
    kquestion.metadata.textInputAnswers.push(this.newStructuredQuestion());
    kquestion.solution.push({
      subItems: []
    });
    this.setState({
      kquestion: kquestion
    })
  },
  removePart: function (index) {
    var _this = this;
    this.confirmable = createConfirm({
      title: 'Warning',
      content: 'Are you sure to delete this part, all content will be lost.'
    }, function () {
      var kquestion = _this.state.kquestion;
      kquestion.textInputAnswers.splice(index, 1);
      kquestion.metadata.textInputAnswers.splice(index, 1);
      kquestion.solution.splice(index, 1);
      _this.setState({
        kquestion: kquestion,
        openConfirmModal: false
      }, function () {
        for (var i = 0; i < kquestion.metadata.textInputAnswers.length; i++) {
          var refOfPart = "TeXEditor-question-" + this.props.questionIndex + "-part-" + i;
          _this.refs[refOfPart]._forceRenderWithContent(kquestion.metadata.textInputAnswers[i].description);
        }
      });
    }, function () {
      _this.setState({
        openConfirmModal: false
      });
    })
    _this.setState({
      openConfirmModal: true
    });
  },
  verifyQuestionData: function () {
    var kquestion = this.state.kquestion;
    kquestion.selectionChoices = [];
    if (!kquestion.textInputAnswers || kquestion.textInputAnswers.length === 0) {
      kquestion.textInputAnswers = [this.newStructuredQuestion()]
    }
    this.setState({
      kquestion: kquestion
    });
  },
  uploadImageDone: function (modelToBind, response) {
    modelToBind.isImageUploading = false;
    modelToBind.image = response.url;
    this.forceUpdate();
  },
  onUploadingImage: function (modelToBind) {
    modelToBind.isImageUploading = true;
    this.forceUpdate();
  },
  onUpdateDescriptionContent: function(event) {
    var HTMLContent = event.editor.getData();
    var rawContent = HTMLContent;
    this.state.kquestion.description = HTMLContent;
    this.state.kquestion.metadata.description = rawContent;
    this.setState({
      kquestion: this.state.kquestion
    });
  },
  onUpdateInputContent: function(textInputIndex, event) {
    var HTMLContent = event.editor.getData();
    var rawContent = HTMLContent;
    var kquestion = this.state.kquestion,
      textInput = kquestion.textInputAnswers[textInputIndex];
    textInput.description = HTMLContent;
    if (!kquestion.metadata.textInputAnswers) kquestion.metadata.textInputAnswers = [];
    if (!kquestion.metadata.textInputAnswers[textInputIndex]) kquestion.metadata.textInputAnswers[textInputIndex] = {};
    kquestion.metadata.textInputAnswers[textInputIndex].description = rawContent;
    this.setState({
      kquestion: kquestion
    });
  },
  onUpdateDescriptionContentTex: function (HTMLContent, rawContent) {
    this.state.kquestion.description = HTMLContent;
    this.state.kquestion.metadata.description = rawContent;
    this.setState({
      kquestion: this.state.kquestion
    });
  },
  onUpdateInputContentTex: function (textInputIndex, HTMLContent, rawContent) {
    var kquestion = this.state.kquestion,
      textInput = kquestion.textInputAnswers[textInputIndex];
    textInput.description = HTMLContent;
    if (!kquestion.metadata.textInputAnswers) kquestion.metadata.textInputAnswers = [];
    if (!kquestion.metadata.textInputAnswers[textInputIndex]) kquestion.metadata.textInputAnswers[textInputIndex] = {};
    kquestion.metadata.textInputAnswers[textInputIndex].description = rawContent;
    this.setState({
      kquestion: kquestion
    });
  },
  onInputMarkChange: function (textInput, e) {
    var mark = parseFloat(e.target.value);
    // Reset error
    this.state.kquestion.sumMarkError = null;
    this.setState({
      kquestion: this.state.kquestion
    }, function () {
      if (mark > this.state.kquestion.score) textInput.errorMessage = '* Part\'s mark should be less than question\'s mark';
      else {
        textInput.errorMessage = null;
        textInput.answerValue = mark;
        textInput.displayAnswerValue = mark;
      }
      this.forceUpdate();
    });
  },
  transformQuestionData: function (kquestion) {
    if (!kquestion.textInputAnswers || kquestion.textInputAnswers.length <= 0) return;
    for (var i = 0; i < kquestion.textInputAnswers.length; i++) {
      kquestion.textInputAnswers[i].displayAnswerValue = kquestion.textInputAnswers[i].answerValue;
    }
  },
  onNewHintAdded: function (solution, subItemIndex) {
    var kquestion = this.state.kquestion;
    var solutionIndex = this.state.kquestion.solution.indexOf(solution);
    if (kquestion.metadata.solution &&
      kquestion.metadata.solution[solutionIndex] &&
      kquestion.metadata.solution[solutionIndex].subItems) {
        const subItems = kquestion.metadata.solution[solutionIndex].subItems;
        const pushedItems = subItems.splice(subItemIndex, subItems.length-subItemIndex, null);
        kquestion.metadata.solution[solutionIndex].subItems = subItems.concat(pushedItems);
        this.forceUpdate();
      }
  },
  onUpdateSolution: function (solution, rawContent, subItemIndex) {
    // branch ckeditor commit this function 
    var kquestion = this.state.kquestion;
    var solutionIndex = this.state.kquestion.solution.indexOf(solution);
    if (!kquestion.metadata.solution) kquestion.metadata.solution = [];
    if (!kquestion.metadata.solution[solutionIndex]) kquestion.metadata.solution[solutionIndex] = { subItems: [] };
    if (!kquestion.metadata.solution[solutionIndex].subItems[subItemIndex])
      kquestion.metadata.solution[solutionIndex].subItems[subItemIndex] = {};
    kquestion.metadata.solution[solutionIndex].subItems[subItemIndex].value = rawContent;
    this.forceUpdate();
  },
  getInitialState: function () {
    return {
      kquestion: this.props.kquestion
    }
  },
  componentWillReceiveProps: function (nextProps) {
    if (nextProps.kquestion) {
      this.transformQuestionData(nextProps.kquestion);
      this.setState({
        kquestion: nextProps.kquestion
      })
    }
  },
  componentWillMount: function () {
    // this.verifyQuestionData();
  },
  render: function () {
    var _this = this;
    console.log('subject', this.props.subject)
    return (
      <div className="question-content-container">
        {_this.state.openConfirmModal && _this.confirmable}
        {/*<div className="row">
          <div className="col-md-6 col-xs-12">
            <ImageUploader onUploading={_this.onUploadingImage.bind(_this, _this.state.kquestion)} onUploadDone={_this.uploadImageDone.bind(_this, _this.state.kquestion)}>
              { !_this.state.kquestion.image &&
                <div className="img-intrinsic input intrinsic-2x1" style={{"background": "#ddd"}}>
                  {_this.state.kquestion.isImageUploading &&
                    <div className="intrinsic-item">
                      <CircularProgress className="loading"/>
                    </div>}
                </div>
              }
              {
                _this.state.kquestion.image && <img src={_this.state.kquestion.image} style={{"width": "100%"}} alt="Question"/>
              }
            </ImageUploader>
          </div>
          <div className="col-md-6 col-xs-12">
            <textarea className="form-control" placeholder="Enter question title here" rows="6" onChange={_this.handleDescriptionChange}></textarea>
          </div>
        </div>*/}
        {/*<hr/>*/}
        <div style={{ marginBottom: "10px" }}>
          <label>Overall Description</label>
              
          {(_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old') ?
            <TeXEditor
              onUpdateContent={_this.onUpdateDescriptionContent}
              initialContent={_this.state.kquestion.metadata.description}
            />
            :
            <CustomEditor 
              activeClass="p10"
              content={_this.state.kquestion.description}
              isScriptLoaded={true}
              events={{
                "change": _this.onUpdateDescriptionContent
              }}
            />
          }
        </div>

        <div className="long-parts">
          {/*
            _this.state.kquestion.textInputAnswers.map(function(textInput, index) {
              return (
                <div className="row choice" key={index}>
                  <div className="col-md-3">
                    <input className="form-control" type="text" placeholder="Pre-text" onChange={_this.handlePreTextChange.bind(_this, textInput)} defaultValue={textInput.preText}/>
                  </div>
                  <div className="col-md-6">
                    <WirisEditor className="form-control" type="text" placeholder="Answer here" onChange={_this.handleAnswerChange.bind(_this, textInput)} content={textInput.text}/>
                  </div>
                  <div className="col-md-3">
                    <input className="form-control" type="text" placeholder="Post-text" onChange={_this.handlePostTextChange.bind(_this, textInput)} defaultValue={textInput.postText}/>
                  </div>
                </div>
              )
            })
          */}
          {
            _this.state.kquestion.textInputAnswers.map(function (textInput, index) {
              return (
                <div className="part" key={index}>
                  <div className="part-title content-toolbar">
                    <h4 className="dp-inline-block">{"Part " + (index + 1)}</h4>
                    <div className="btn-holder">
                      <i
                        data-tip data-for={"tt-part-" + index}
                        className="fa fa-trash"
                        style={{ cursor: "pointer" }}
                        onClick={_this.removePart.bind(_this, index)}></i>
                    </div>
                    <ReactTooltip id={"tt-part-" + index} effect="solid">Remove part</ReactTooltip>
                  </div>
                  <div className="part-content">
                    <div className="row margin-bottom-10">
                      <div className="col-md-2">
                        <label>Marks</label>
                      </div>
                      <div className="col-md-10">
                        <input
                          type="number"
                          min="0"
                          className={"form-control mark-input" + ((textInput.errorMessage || _this.state.kquestion.sumMarkError) ? " error" : "")} placeholder={"Mark for part " + (index + 1)}
                          value={textInput.displayAnswerValue}
                          onChange={_this.onInputMarkChange.bind(_this, textInput)} />
                        {
                          textInput.errorMessage && <span className="mark-error">{textInput.errorMessage}</span>
                        }
                      </div>
                    </div>
                    <div className="row margin-bottom-10">
                      <div className="col-md-2">
                        <label>Content</label>
                      </div>
                      <div className="col-md-10">
                        {(_this.state.kquestion.subtype && _this.state.kquestion.subtype.editor === 'old') ?
                        <TeXEditor
                          onUpdateContent={_this.onUpdateInputContentTex.bind(_this, index)}
                          initialContent={(_this.state.kquestion.metadata.textInputAnswers && _this.state.kquestion.metadata.textInputAnswers[index]) ? _this.state.kquestion.metadata.textInputAnswers[index].description : null}
                          ref={"TeXEditor-question-" + _this.props.questionIndex + "-part-" + index}
                        />
                        :
                        <CustomEditor 
                          activeClass="p10" 
                          content={(_this.state.kquestion.textInputAnswers && _this.state.kquestion.textInputAnswers[index]) ? _this.state.kquestion.textInputAnswers[index].description : null}
                          isScriptLoaded={true}
                          events={{
                            "change": _this.onUpdateInputContent.bind(_this, index)
                          }}
                         />
                        }
                      </div>
                    </div>
                    <div>
                      <Solution4LongQ
                        kquestion={_this.state.kquestion}
                        subject={_this.props.subject}
                        questionIndex={_this.props.questionIndex}
                        onNewHintAdded={_this.onNewHintAdded.bind(_this, _this.state.kquestion.solution[index])}
                        partIndex={index}
                        solution={_this.state.kquestion.solution[index].subItems}
                        onUpdateSolution={_this.onUpdateSolution.bind(_this, _this.state.kquestion.solution[index])}
                        initialItems={_this.state.kquestion.solution[index].subItems}
                      />
                    </div>
                  </div>
                </div>
              )
            })
          }
          <RaisedButton
            label="Add part"
            primary={true}
            onClick={_this.addPart}
          />
        </div>
        <hr />
      </div>
    )
  },

  componentDidMount: function () {
    if (this.state.kquestion) {
      this.transformQuestionData(this.state.kquestion);
      this.setState({
        kquestion: this.state.kquestion
      })
    }
  },
})

export default LongQuestionEditor;



/** WEBPACK FOOTER **
 ** ./src/components/CollectionEditor/LongQuestion.js
 **/